const g = globalThis;
const ns = g.riseNavigation = {};

Object.assign(ns, {
  context: g.document,
  menuTitle: 'Rise',
  urlTokens: {
    usbrUrl: 'https://www.usbr.gov',
    riseUrl: 'https://data.usbr.gov',
    mapUrl:  'https://data.usbr.gov',
  },
});

ns.breadcrumbs = [
  {                 label: 'Reclamation',    url: '{usbrUrl}',                key: 'usbr' },
  { parent: 'usbr', label: 'RISE',           url: '{riseUrl}',                key: 'rise' },
  { parent: 'rise', label: 'Visualizations', url: '{riseUrl}/visualizations', key: 'visualizations' },
];

ns.menuItems = [
  { label: 'Home',              url: '{riseUrl}',                key: 'index' },
  { label: 'Catalog',           url: '{riseUrl}/catalog',        key: 'catalog' },
  { label: 'Map Interface',     url: '{mapUrl}/rise-map',        key: 'map', open: true },
  { label: 'Time Series Query', url: '{riseUrl}/time-series',    key: 'time-series' },
  { label: 'RISE API',          url: '{riseUrl}/rise-api',       key: 'rise-api' },
  { label: 'Visualizations',    url: '{riseUrl}/visualizations', key: 'visualizations' },
  { label: 'Contact Us',        url: '{riseUrl}/contact',        key: 'contact' },
  { label: 'Help',              url: '{riseUrl}/help',           key: 'help' },
  { label: 'About RISE',        url: '{riseUrl}/about',          key: 'about' },
];

Object.assign(ns, {
  initMainMenu, setUrlTokens, replaceUrlTokens,
  createBreadcrumbs, addBreadcrumb, removeBreadcrumb, selectBreadcrumb,
  createMenu, createMenuToggle, addMenuItem, removeMenuItem, selectMenuItem,
});

ns.externalIconId = 'rise_external_link_icon';
ns.externalIcon = `<svg id="${ns.externalIconId}" viewBox="0 0 1800 1800"><path d="m 1408,928 v 320 q 0,119 -84.5,203.5 Q 1239,1536 1120,1536 H 288 Q 169,1536 84.5,1451.5 0,1367 0,1248 V 416 Q 0,297 84.5,212.5 169,128 288,128 h 704 q 14,0 23,9 9,9 9,23 v 64 q 0,14 -9,23 -9,9 -23,9 H 288 q -66,0 -113,47 -47,47 -47,113 v 832 q 0,66 47,113 47,47 113,47 h 832 q 66,0 113,-47 47,-47 47,-113 V 928 q 0,-14 9,-23 9,-9 23,-9 h 64 q 14,0 23,9 9,9 9,23 z M 1792,64 v 512 q 0,26 -19,45 -19,19 -45,19 -26,0 -45,-19 L 1507,445 855,1097 q -10,10 -23,10 -13,0 -23,-10 L 695,983 q -10,-10 -10,-23 0,-13 10,-23 L 1347,285 1171,109 q -19,-19 -19,-45 0,-26 19,-45 19,-19 45,-19 h 512 q 26,0 45,19 19,19 19,45 z" /></svg>`;
ns.externalIconUse = `<svg width="16" height="16"><use xlink:href="#${ns.externalIconId}"></use></svg>`;

ns.breadcrumbItems = [];
ns.submenuTree = {};
ns.submenuItems = [];

const itemClass = 'l-secondary-nav__item';
const activeItemClass = `${itemClass}--active`;
const activeParentItemClass = '-active';
const activeMenuButtonClass = '-active';

function setUrlTokens(vars) {
  Object.assign(ns.urlTokens, vars);
  return ns;
}

function replaceUrlTokens(string) {
  if (!string) {
    return string;
  }
  Object.entries(ns.urlTokens).forEach(([ k, v ]) => {
    string = string.replace(`{${k}}`, v);
  });
  return string;
}

function getBreadcrumbUrl(breadcrumbItemOrIndex) {
  if (typeof breadcrumbItemOrIndex !== 'object') {
    breadcrumbItemOrIndex = ns.breadcrumbs[breadcrumbItemOrIndex];
  }
  return replaceUrlTokens(breadcrumbItemOrIndex?.url);
}

function getMenuUrl(menuItemOrIndex) {
  if (typeof menuItemOrIndex !== 'object') {
    menuItemOrIndex = ns.menuItems[menuItemOrIndex];
  }
  return replaceUrlTokens(menuItemOrIndex?.url);
}

const matchWhitespace = /\s+/g;

function select(selector) {
  return selector instanceof Element ? selector
    : ns.context.querySelector(selector);
}

function splitClasses(classes) {
  let result = [];
  [].concat(classes).forEach(cls =>
    cls?.split(matchWhitespace).forEach(cls => {
      if (cls) {
        result.push(cls);
      }
    })
  );
  return result;
}

function slide(el, { duration = 200, show, hide } = {}) {
  const { slideToggle } = el.dataset;
  show ??= hide === false || hide === true ? false
    : (slideToggle === 'hidden' || !slideToggle && el.offsetHeight === 0);
  const visibility = show ? 'visible' : 'hidden';
  if (slideToggle === visibility) {
    return;
  }
  dom(el, { attrs: { 'data-slide-toggle': visibility } });
  if (show) {
    dom(el, { style: { height: 'auto', overflow: 'hidden' } });
    el.style.removeProperty('display');
    const { display } = g.getComputedStyle(el);
    if (display === 'none') {
      el.style.display = 'block';
    }
    el.animate([{ height: '0px' }, { height: `${el.offsetHeight}px` }], { duration })
      .addEventListener('finish', () => {
        dom(el, { style: { height: '', overflow: '' } });
      });
  } else {
    dom(el, { style: { overflow: 'hidden' } });
    el.animate([{ height: `${el.offsetHeight}px` }, { height: '0px' }], { duration })
      .addEventListener('finish', () => {
        dom(el, { style: { overflow: '', display: 'none' } });
      });
  }
}

function dom(el, options = {}) {
  const { attrs, class: cls, html, text, prependTo, appendTo, style } = options;
  const c = ns.context;
  if (typeof el === 'string') {
    el = c.createElement(el);
  }
  const classes = splitClasses(cls);
  if (classes) {
    el.classList.add(...classes);
  }
  if (attrs) {
    Object.entries(attrs)
      .forEach(([ key, value ]) => el.setAttribute(key, value));
  }
  if (style) {
    Object.assign(el.style, style);
  }
  if (prependTo) {
    select(prependTo).prepend(el);
  } else if (appendTo) {
    select(appendTo).append(el);
  }
  if (html) {
    el.innerHTML = html;
  } else if (text) {
    el.innerText = text;
  }
  return el;
}

function setNavItemFocusable(navItem, focusable = true) {
  navItem.querySelectorAll('.Nav-sublist-link').forEach(link =>
    focusable ? link.setAttribute('tabindex', '-1')
      : link.removeAttribute('tabindex')
  );
}

function hideNavItems(navItems) {
  navItems?.forEach(item => {
    if (!item.matches('.-active')) {
      return;
    }
    item.classList.remove('-active');
    setNavItemFocusable(item);
  });
}

function initMainMenu() {
  const { context: c } = ns;
  const header = c.querySelector('.Header-wrap');
  const nav = c.querySelector('.Nav');
  const items = nav?.querySelectorAll('.Nav-item');
  let isOpen = false;
  if (header && nav) {
    header.classList.add('-navigationActive');
    const toggleButton = dom('button', {
      class: 'Nav-toggle',
      text: 'Menu',
      appendTo: header,
    });
    toggleButton.addEventListener('click', () => {
      toggleButton.innerText = isOpen ? 'Menu' : 'Close';
      isOpen = !isOpen;
      slide(nav);
      nav.classList.toggle('-active');
    });
  }
  items?.forEach(item => {
    setNavItemFocusable(item);
    item.addEventListener('click', e => {
      if (e.target.parentNode.closest('.Nav-sublist')) {
        return;
      }
      e.preventDefault();
      if (item.matches('.-active') ) {
        item.classList.remove('-active');
      } else {
        hideNavItems(items);
        item.classList.add('-active');
        item.querySelectorAll('.Nav-sublist-link')
          .forEach(link => link.removeAttribute('tabindex'));
        setNavItemFocusable(item, false);
      }
    });
  });
  c.body.addEventListener('click', e => {
    if (e.target.parentNode.closest('.Nav') || e.target.matches('.Nav-toggle')) {
      return;
    }
    hideNavItems(items);
  });
  return ns;
}

function initExternalIcon() {
  const { context: c } = ns;
  if (ns.context.querySelector(`#${ns.externalIconId}`)) {
    return;
  }
  dom('div', {
    style: { display: 'none' },
    html: ns.externalIcon,
    appendTo: c.body,
  });
}

let breadcrumbListEl;
function initBreadcrumbs(parent = null) {
  if (breadcrumbListEl) {
    return;
  }
  initExternalIcon();
  const c = ns.context;
  if (typeof parent === 'string') {
    parent = c.querySelector(parent);
    if (!parent) {
      throw new Error('Unable to query parent by given selector');
    }
  }
  if (!parent) {
    parent = c.querySelector('.Breadcrumbs');
    if (!parent) {
      throw new Error('Unable to query parent by known selectors. Try adding <div class="Breadcrumbs"></div> to your HTML.');
    }
  }
  if (!parent.matches('ul')) {
    if (!parent.matches('.Breadcrumbs')) {
      parent = dom('div', { class: 'Breadcrumbs', appendTo: parent });
    }
    parent = parent.querySelector('ul')
      || dom('ul', { appendTo: parent });
  }
  dom(parent, { class: 'resetList' });
  breadcrumbListEl = parent;
}

let selectedBreadcrumb = 'rise';
function renderBreadcrumbs() {
  const { breadcrumbs, breadcrumbItems } = ns;
  const byKey = i => i.key === selectedBreadcrumb;
  let selected = breadcrumbItems.find(byKey);
  const isSubMenu = !!selected;
  const crumbs = [];
  if (isSubMenu) {
    crumbs.push(selected);
    while (selected.parent) {
      const { parent } = selected;
      const byKey = i => i.key === parent;
      const s = breadcrumbItems.find(byKey);
      if (!s) {
        break;
      }
      crumbs.push(selected = s);
    }
  } else {
    selected = breadcrumbs.find(byKey);
    if (selected) {
      crumbs.push(selected);
    }
  }
  while (selected?.parent) {
    const { parent } = selected;
    const byKey = i => i.key === parent;
    selected = breadcrumbs.find(byKey);
    if (!selected) {
      break;
    }
    crumbs.push(selected);
  }
  breadcrumbListEl.innerText = '';
  for (let i = crumbs.length - 1; i >= 0; --i) {
    const crumb = crumbs[i];
    const el = dom('li', { appendTo: breadcrumbListEl });
    dom('a', {
      attrs: { href: getBreadcrumbUrl(crumb) },
      text: crumb.label,
      appendTo: el,
    });
  }
}

function createBreadcrumbs(parent = null) {
  initBreadcrumbs(parent);
  renderBreadcrumbs();
  return ns;
}

function addBreadcrumb(...items) {
  const { breadcrumbItems } = ns;
  breadcrumbItems.push(...items);
  renderBreadcrumbs();
  return ns;
}

function removeBreadcrumb(...items) {
  const { breadcrumbItems } = ns;
  items.forEach(i => {
    const index = breadcrumbItems.findIndex(bi =>
      typeof i !== 'object' ? i === bi.key
        : i.key ? i.key === bi.key: i === bi
    );
    if (index >= 0) {
      breadcrumbItems.splice(index, 1);
    }
  });
  renderBreadcrumbs();
  return ns;
}

function selectBreadcrumb(key) {
  selectedBreadcrumb = (key && typeof key === 'object' ? key.key : key) || 'rise';
  renderBreadcrumbs();
  return ns;
}

const knownMenuParents = [ '.LeftNav', '.Main-nav' ];

let menuEl, menuListEl;
function initMenu(parent = null) {
  if (menuEl) {
    return;
  }
  initExternalIcon();
  const c = ns.context;
  if (typeof parent === 'string') {
    parent = c.querySelector(parent);
    if (!parent) {
      throw new Error('Unable to query parent by given selector');
    }
  }
  const p = parent;
  knownMenuParents.some(cls => {
    const node = (p || c).querySelector(cls);
    if (node) {
      parent = node;
    }
    return node;
  });
  if (!parent) {
    throw new Error('Unable to query parent by known selectors. Try adding <div class="Main-nav"></div> to your HTML.');
  }
  if (!parent.matches(knownMenuParents.join(', '))) {
    parent = dom('div', { class: 'Main-nav', appendTo: parent });
  }
  if (parent.matches('.Main-nav')) {
    parent = dom('div', { class: 'LeftNav', appendTo: parent });
  }
  menuEl = parent;
  menuEl.classList.add('LeftNav');
  menuEl.setAttribute('role', 'navigation');
  const title = menuEl.querySelector('.LeftNav-title')
    || dom('span', { class: 'LeftNav-title', appendTo: menuEl });
  title.innerText = ns.menuTitle;
  menuListEl = menuEl.querySelector('.LeftNav-list')
    || dom('ul', { class: 'LeftNav-list', appendTo: menuEl });
}

function createMenu(parent = null) {
  initMenu(parent);
  menuListEl.innerText = '';
  ns.menuItems.forEach(item => _appendMenuItem(menuListEl, item));
  createMenuToggle();
  return ns;
}

function createMenuToggle(parent = null) {
  initMenu(parent);
  const button = dom('button', {
    class: 'LeftNav-titleButton',
    text: menuEl.querySelector('.LeftNav-title')?.innerText || ns.menuTitle,
    prependTo: menuEl,
  });
  menuEl.classList.add('-interactive');
  menuListEl.style.display = 'none';
  button.addEventListener('click', () => {
    slide(menuListEl);
    button.classList.toggle(activeMenuButtonClass);
  });
  return ns;
}

function addMenuItem(...items) {
  const { submenuItems, submenuTree } = ns;
  submenuItems.push(...items);
  items.forEach(item => {
    const parent = item.parent ??= 'visualizations';
    (submenuTree[parent] ??= []).push(item);
    if (menuEl) {
      appendMenuItem(parent, item);
    }
  });
  selectMenuItem(selectedMenuItem);
  return ns;
}

function removeMenuItem(...items) {
  const { submenuItems, submenuTree } = ns;
  items.forEach(i => {
    const index = submenuItems.findIndex(bi =>
      typeof i !== 'object' ? i === bi.key
        : i.key ? i.key === bi.key: i === bi
    );
    if (index >= 0) {
      const item = submenuItems[index];
      item.el?.remove();
      submenuItems.splice(index, 1);
      const parent = submenuTree[item.parent ?? 'visualizations'];
      const treeIndex = parent?.findIndex(c => c === item);
      if (treeIndex >= 0) {
        parent.splice(treeIndex, 1);
      }
    }
  });
  selectMenuItem(selectedMenuItem);
  return ns;
}

function appendMenuItem(parent, ...items) {
  if (typeof parent !== 'object') {
    parent = ns.menuItems.find(i => i.key === parent)
      || ns.submenuItems.find(i => i.key === parent);
  }
  if (!parent.el) {
    return;
  }
  parent = parent.el.querySelector('ul') || dom('ul', { appendTo: parent.el });
  items.forEach(item => _appendMenuItem(parent, item));
}

let selectedMenuItem;
function selectMenuItem(key) {
  selectedMenuItem = key;
  const { menuItems, submenuItems, submenuTree } = ns;
  let findItem = (list, key) => list.find(i => i.key === key);
  if (typeof key === 'object') {
    if (key.key) {
      key = key.key;
    } else {
      findItem = (list, ref) => list.find(i => i === ref);
    }
  }
  let selected = findItem(submenuItems, key);
  const isSubMenu = !!selected;
  if (isSubMenu) {
    const tree = [ selected ];
    while (selected.parent) {
      const { parent } = selected;
      selected = findItem(submenuItems, parent) ?? findItem(menuItems, parent);
      if (!selected) {
        break;
      }
      tree.push(selected);
    }
    selected = tree;
  } else {
    selected = findItem(menuItems, key);
    selected = selected ? [ selected ] : [];
  }
  submenuItems.forEach(item => {
    let parent = item;
    while (parent.parent) {
      parent = findItem(submenuItems, parent.parent) ?? findItem(menuItems, parent.parent);
    }
    const isVisible = selected?.includes(parent);
    const { el } = item;
    if (isVisible) {
      const isSelected = selected?.includes(item);
      el.classList.toggle(activeItemClass, isSelected);
      el.style.removeProperty('display');
    } else {
      el.style.display = 'none';
    }
  });
  menuItems.forEach(item => {
    const { classList } = item.el;
    const isSelected = !!selected?.includes(item);
    classList.toggle(activeItemClass, isSelected);
    classList.toggle(activeParentItemClass, !!(isSelected && submenuTree[item.key]?.length));
  });
  return ns;
}

function _appendMenuItem(appendTo, item, cls = null) {
  const { key } = item;
  const el = dom('li', {
    class: itemClass + (cls ? ' ' + cls : '') ,
    appendTo
  });
  item.el = el;
  const link = dom('a', {
    attrs: { href: getMenuUrl(item) },
    text: item.label,
    appendTo: el,
  });
  if (item.open) {
    dom(link, {
      attrs: { rel: 'noopener noreferrer', target: '_blank' },
      appendTo: el,
    });
    const open = dom('span', {
      class: 'c-links-to__external-icon c-links-to__external-icon--external',
      appendTo: link,
    });
    dom('span', {
      class: 'c-icon c-icon--external-link',
      attrs: { title: 'Opens in new window' },
      html: ns.externalIconUse,
      appendTo: open,
    });
    dom('span', {
      class: 'c-icon__text',
      text: 'Opens in new window',
      appendTo: open,
    });
  }
  const children = ns.submenuTree[key];
  if (children?.length) {
    children.forEach(child => _appendMenuItem(el, child));
  }
}
